import React from 'react';

interface INicheTutorSvgProps {
  width?: number;
  height?: number;
}

export const NicheTutorSvg: React.FC<INicheTutorSvgProps> = ({
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 27V15.5L20 10L32 15.5V27"
        stroke="#4CAF50"
        strokeWidth="1.5"
        fill="none"
        strokeLinejoin="round"
      />
      <line
        x1="20"
        y1="10"
        x2="20"
        y2="27"
        stroke="#4CAF50"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
